import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

const INTERCEPTOR_DISALLOW_PATHS = [
  'metrics/engagement'
];

@Injectable()
export class SessionIdInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Prevent `auth-session-id` from being added to requests in the disallow list
    if (INTERCEPTOR_DISALLOW_PATHS.some(path => req.url.includes(path))) {
      return next.handle(req);
    }

    return next.handle(req.clone({ setHeaders: { 'auth-session-id': sessionStorage.getItem('auth-session-id') } }));
  }
}
